<template>
  <div class="sum-params">
    <div class="sum-item">
      <div class="key">{{ $t('fms_accounts_footer_sum.yi_xuan_zhong') }}</div>
      <div class="val selected-num">{{ data.length }}</div>
      <div class="key">{{ $t('fms_accounts_footer_sum.xiang') }}，</div>
    </div>
    <div class="sum-item">
      <div class="key">{{ $t('fms_accounts_footer_sum.he_ji') }}：</div>
      <div class="val sum" v-if="total === undefined">{{ selectedSum | formatThousandth }}</div>
      <div class="val sum" v-else>{{ total }}</div>
    </div>
    <div class="sum-item ml-10" v-if="totalPaymentAmount !== -1">
      <div class="key">{{ $t('fms_accounts_footer_sum.zhang_dan_zong_jin_e') }}：</div>
      <div class="val price">{{ totalPaymentAmount | formatThousandth }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    total: [Number],
    totalPaymentAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedSum() {
      const list = this.data || [];
      const sum = list.reduce((total, item) => total + item.paymentAmount, 0);
      return sum;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.sum-params {
  float: left;
  overflow: hidden;

  .selected-num {
    padding: 0 5px;
    color: #0d9ae0;
  }
  .sum,
  .price {
    color: #0d9ae0;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .sum-item {
    float: left;
    line-height: 32px;
    font-size: 12px;
    color: #606266;
    .key,
    .val {
      float: left;
    }
  }
}
</style>
